import { mobileWidth } from "./settings";

export const initProduct = () => {
    if (document.body.classList.contains("single-product")) {
        initProductTabs();
        initProductReviews();
        initProductInfo();
    }

    if (document.querySelectorAll(".product-variations").length) {
        initProductVariations();
    }

    if (document.querySelectorAll(".product-variations-repl").length) {
        initProductVariationReplacement();
    }
    // delayed (first jquery init needed)
    setTimeout(function () {
        initProductGallery();
    }, 10);

    // delayed (first jquery init needed)
    setTimeout(function () {
        moveInStockInfoToHolder();
    }, 500);
};

const moveInStockInfoToHolder = () => {
    const stockHolder = document.querySelector("#stock-holder");
    const stockDivs = document.querySelectorAll("form.cart .stock");
    const stockDiv = stockDivs[stockDivs.length - 1];

    if (stockDiv && stockHolder) {
        stockHolder.innerHTML = "";
        stockHolder.append(stockDiv);
    }
};

const initProductGallery = () => {
    const gallery = document.querySelector(".woocommerce-product-gallery");
    const thumbs = document.querySelectorAll(".flex-control-thumbs li");
    if (gallery) {
        const max = gallery.dataset.columns;
        if (thumbs.length >= max) {
            const lastThumb = thumbs[max - 1];
            lastThumb.classList.add("last-plus");
            const span = document.createElement("span");
            span.innerHTML = `+${thumbs.length - max}`;
            lastThumb.append(span);
        }
    }
};

const initProductTabs = () => {
    const productTabs = document.querySelectorAll(".product-tab");

    productTabs.forEach(function (tab) {
        tab.addEventListener("click", () => {
            resetProductTabIcons();

            const i = tab.id.split("-")[2];
            const icon = document.getElementById("tab-icon-" + i);

            if (icon.style.transform === "rotate(180deg)") {
                icon.style.transform = "rotate(0deg)";
            } else {
                icon.style.transform = "rotate(180deg)";
            }
        });
    });

    const resetProductTabIcons = () => {
        productTabs.forEach((tab) => {
            const icon = document.getElementById(
                "tab-icon-" + tab.id.split("-")[2],
            );
            icon.style.transform = "rotate(0deg)";
        });
    };
};

const initProductReviews = () => {
    const reviewStars = document.querySelectorAll(".start-review a");

    reviewStars.forEach(function (elem) {
        elem.addEventListener("click", (e) => {
            document
                .querySelector("#review_form_wrapper")
                .classList.add("open");
            const rating = elem.dataset.rating;
            setTimeout(() => {
                jQuery("#commentform a.star-" + rating).click();
            }, 1500);
        });
    });

    const readMore = document.querySelector(".read-more-btn");
    if (readMore) {
        const tabClone = document
            .querySelector(".woocommerce-tabs")
            .cloneNode(true);

        const popup = document.getElementById("tabs-popup");
        popup.querySelector(".tabs-popup-body").appendChild(tabClone);

        readMore.addEventListener("click", (e) => {
            if (window.innerWidth > mobileWidth) {
                const popup = document.getElementById("tabs-popup");
                popup.classList.add("show");
            } else {
                readMore.parentNode.classList.toggle("open");

                toggleInnerText(event.currentTarget, [
                    "Lees meer",
                    "Inklappen",
                ]);
            }
        });
    }
};

const initProductInfo = () => {
    const popupClose = document.querySelectorAll(
        ".tabs-popup .close-btn, .tabs-popup-bg",
    );
    popupClose.forEach(function (elem) {
        elem.addEventListener("click", (e) => {
            const popup = document.getElementById("tabs-popup");
            popup.classList.remove("show");
        });
    });
};

const initProductVariationReplacement = () => {
    const productVariationsRepl = document.querySelector(
        ".product-variations-repl",
    );
    const productGroups = productVariationsRepl.querySelectorAll(
        ".product-variation-group",
    );

    const variationsActive = productVariationsRepl.querySelectorAll(
        ".product-variation.active",
    );

    const numVariationGroups = productGroups.length;
    const numVariationsActive = variationsActive.length;
    const hasEnoughActive = numVariationsActive == numVariationGroups;

    productVariationsRepl
        .querySelector(".select-all-variations-message")
        ?.classList?.toggle("hidden", hasEnoughActive);

    if (productGroups && hasEnoughActive) {
        productGroups.forEach(function (group) {
            const activeElement = group.querySelector(
                ".product-variation.active",
            );

            if (activeElement) {
                const activeLabel = activeElement.dataset.label;
                const variationId = activeElement.dataset.id;
                setAttributesFromVariantId(variationId);
                const key = activeElement.dataset.key;
                if (activeElement.classList.contains("set_title")) {
                    const element = document.querySelector("#" + key);
                    if (element) {
                        element.innerHTML = activeLabel;
                    }
                }
            } else {
                clearVarNaming();
            }
        });
    } else {
        clearVarNaming();
    }
};

const initProductVariations = () => {
    const productVariationButtons =
        document.querySelectorAll(".product-variation");

    const badge =
        document.querySelector(".with-badge .badge")?.cloneNode(true) ?? false;

    const variationDataElement = document.querySelector(".variations_form");
    const variationData = variationDataElement
        ? JSON.parse(variationDataElement.dataset.product_variations)
        : [];

    const selectVariationOption = (selectElement, value) => {
        if (!selectElement) return;

        // Set the value of the select element
        selectElement.value = value;

        // Trigger the change event to let WooCommerce handle the update
        var event = new Event("change", { bubbles: true });
        selectElement.dispatchEvent(event);

        // Trigger the change event on the product form
        var productForm = selectElement.closest("form.variations_form");
        if (productForm) {
            jQuery(productForm).trigger("check_variations");
        }
    };

    const getProductVariation = () => {
        const variationGroups = document.querySelectorAll(
            ".entry-summary .product-variations .product-variation-group",
        );
        const numVariationGroups = variationGroups.length;
        const variationsActive = document.querySelectorAll(
            ".entry-summary .product-variations .product-variation-group .active",
        );
        const numVariationsActive = variationsActive.length;
        const hasEnoughActive = numVariationsActive == numVariationGroups;

        document
            .querySelector(".select-all-variations-message")
            ?.classList?.toggle("hidden", hasEnoughActive);

        if (hasEnoughActive) {
            const checks = [];
            variationsActive.forEach((active, index) => {
                checks.push({
                    name: active.dataset.name,
                    value: active.dataset.value,
                });
            });

            const varIndex = variationData.findIndex((element) => {
                let found = 0;
                checks.forEach((check) => {
                    if (
                        element.attributes["attribute_" + check.name] ==
                        check.value
                    ) {
                        found++;
                    }
                });
                if (found == numVariationGroups) {
                    return true;
                }
                return false;
            });
            return variationData[varIndex];
        } else {
            clearVarNaming();
        }

        return false;
    };

    const setProductVariation = (variation, isTrusted) => {
        if (isTrusted) {
            // triggered via actual click
            setProductVariationUrl(variation);
        }

        const price_div = document.querySelector(".summary .price");
        if (price_div) {
            price_div.innerHTML = variation.price_html.replace("&nbsp;", "");
            if (badge) {
                // price_div.appendChild(badge);
                dom.i2svg({ node: price_div });
            }
        }

        const availability_div = document.querySelector(
            ".woocommerce-variation-availability",
        );

        if (availability_div) {
            dom.i2svg({ node: availability_div });
        }

        if (typeof variation.points_earned !== "undefined") {
            document.querySelector(".points").innerHTML =
                variation.points_earned;
        }

        moveInStockInfoToHolder();
    };

    const setProductVariationUrl = (variation) => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.forEach((_value, key) => {
            if (key.startsWith("attribute_")) {
                params.delete(key);
            }
        });
        Object.entries(variation.attributes).forEach(([key, value]) => {
            params.set(key, value);
        });
        url.search = params.toString();
        history.replaceState(null, null, url.href);
    };

    productVariationButtons.forEach(function (elem) {
        elem.addEventListener("click", (event) => {
            const name = elem.dataset.name;
            const value = elem.dataset.value;
            const label = elem.dataset.label;
            const element = document.querySelector("#" + name);
            const key = elem.dataset.key;

            if (elem.classList.contains("set_title")) {
                document.querySelector("#" + key).innerHTML = label;
            }
            selectVariationOption(element, value);

            const variations = document.querySelectorAll(
                ".product-variation." + name,
            );

            variations.forEach(function (variant) {
                variant.classList.remove("active");
            });
            elem.classList.add("active");

            const variation = getProductVariation();
            if (variation) {
                const id = variation.id || variation.variation_id;
                setAttributesFromVariantId(id);
                setProductVariation(variation, event.isTrusted);
            } else {
                clearVarNaming();
            }
        });
    });

    // click first item so it can be added to the cart right away
    // if variation is already selected (us that one    )
    const variation = getProductVariation();
    if (variation) {
        // we have a varation so click to activate
        document
            .querySelectorAll(
                ".entry-summary .product-variations .product-variation-group button.active",
            )
            .forEach(function (elem) {
                elem.click();
            });
    } else {
        // no variation so click first available per group
        document
            .querySelectorAll(
                ".entry-summary .product-variations .product-variation-group",
            )
            .forEach(function (group) {
                const availableActiveButton = group.querySelector(
                    "button.available.active",
                );
                if (availableActiveButton) {
                    availableActiveButton.click();
                } else {
                    const availableButton =
                        group.querySelector("button.available");
                    if (availableButton) {
                        availableButton.click();
                    }
                }
            });
    }
};

document.querySelectorAll(".bundle-product").forEach(function (bundle) {
    const productId = bundle.getAttribute("id");
    const quantityInput = bundle.querySelector("input[name='quantity']");
    const wrapper = document.querySelector("#inhoud-bundle");
    const form = wrapper.querySelector(`.bundle_form[action*='add-to-cart']`);
    if (!form) {
        return;
    }
    const submitbtn = form.querySelector("button.add_to_cart_bulk");

    wrapper
        .querySelectorAll(".products .bundle-product p.price")
        .forEach((priceElement) => {
            priceElement.innerHTML = priceElement.innerHTML.replace(
                /&nbsp;/g,
                "",
            );
        });

    if (quantityInput) {
        quantityInput.addEventListener("change", function () {
            submitbtn.disabled = true;
            submitbtn.classList.add("loading");
            // submitbtn.removeAttribute("disabled");
            const action = document.querySelector(
                `.bundle_form[action*='add-to-cart']`,
            ).action;
            const match = action.match(new RegExp(`${productId}:\\d+`));
            if (match) {
                document.querySelector(
                    `.bundle_form[action*='add-to-cart']`,
                ).action = action.replace(
                    match[0],
                    `${productId}:${quantityInput.value}`,
                );
            } else {
                document.querySelector(
                    `.bundle_form[action*='add-to-cart']`,
                ).action += `,${productId}:${quantityInput.value}`;
            }

            const prices = wrapper.querySelectorAll(
                ".bundle-cart-total .price .woocommerce-Price-amount",
            );

            const products = document.querySelectorAll(".bundle-product");
            const totalPrice = Array.from(products).reduce((total, product) => {
                const quantityInput = product.querySelector(
                    "input[name='quantity']",
                );
                const productPriceElement = product.querySelector(
                    ".price > ins span.woocommerce-Price-amount, .price > span.woocommerce-Price-amount",
                );
                if (productPriceElement) {
                    const productPrice = parseFloat(
                        productPriceElement.innerHTML
                            .replace(/[^\d.,]/g, "")
                            .replace(",", "."),
                    );
                    if (!isNaN(productPrice)) {
                        return (
                            total +
                            productPrice * parseFloat(quantityInput?.value || 0)
                        );
                    }
                }
                return total;
            }, 0);
            prices.forEach((price) => {
                setTimeout(() => {
                    price.innerHTML = totalPrice.toFixed(2).replace(".", ",");
                }, 500);
            });

            setTimeout(() => {
                submitbtn.disabled = false;
                submitbtn.classList.remove("loading");
            }, 550);
        });
    }
});

document.querySelectorAll("button.add_to_cart_bulk").forEach((elem) => {
    elem.addEventListener("click", async (event) => {
        event.preventDefault();
        const form = elem.closest("form.bundle_form");
        if (form) {
            const formData = new FormData(form);
            const ajaxUrl = form.getAttribute("action");
            const submitbtn = form.querySelector("button.add_to_cart_bulk");
            submitbtn.disabled = true;
            submitbtn.classList.add("adding");
            try {
                const response = await fetch(ajaxUrl, {
                    method: "POST",
                    body: formData,
                });
                const data = await response.text();
                const totalPriceElement = document.querySelector(
                    ".bundle-total-price .woocommerce-Price-amount",
                );
                if (totalPriceElement) {
                    totalPriceElement.innerHTML = data;
                }
                window.location.href = window.location.href; // disable to disable page resfresh on add to cart
            } finally {
                submitbtn.disabled = false;
                submitbtn.classList.remove("adding");
                // const message = document.querySelector(
                //     "#inhoud-bundle #bulk-add-to-cart-message",
                // );
                // if (message) {
                //     message.classList.remove("hidden");
                //     setTimeout(() => {
                //         message.classList.add("hidden");
                //     }, 2500);
                // }
            }
        }
    });
});

function setAttributesFromVariantId(selectedVariation) {
    const skuNo = document.querySelector(".sku-no");
    const topVariant = skuNo.querySelector(".text-accent span");
    const globalUniqueIDtab = document.querySelector(".meta.global_unique_id");
    const eanTAB = document.querySelector(".meta .value.global_unique_id");
    const skuTAB = document.querySelector(".meta .value.sku");
    const stockVariation = document.querySelector(
        ".stock-quantity p.stock.in-stock span",
    );

    const searchInto = JSON.parse(
        document.querySelector("form.variations_form").dataset
            .product_variations,
    );

    if (selectedVariation) {
        const variation = searchInto.find(
            (v) => v.variation_id == selectedVariation,
        );

        if (variation) {
            const sku = variation.sku;
            const ean = variation.ean;
            const stock = variation.max_qty;

            if (skuNo.classList.contains("hidden") && (ean || sku)) {
                skuNo.classList.remove("hidden");
            }

            if (topVariant) {
                if (ean !== undefined) {
                    topVariant.innerHTML = "EAN: " + ean;
                } else if (sku !== undefined) {
                    topVariant.innerHTML = "SKU: " + sku;
                } else {
                    topVariant.innerHTML = "";
                    skuNo.classList.add("hidden");
                }
            }

            if (eanTAB && ean) {
                if (globalUniqueIDtab.classList.contains("hidden")) {
                    globalUniqueIDtab.classList.remove("hidden");
                }
                eanTAB.innerHTML = ean;
            }

            if (skuTAB && sku) {
                skuTAB.innerHTML = sku;
            }

            if (stock && stockVariation) {
                stockVariation.innerHTML = stockVariation.innerHTML.replace(
                    /\d+/,
                    stock,
                );
            }
        }
    }
}

function clearVarNaming() {
    const skuNo = document.querySelector(".sku-no");
    const globalUniqueIDtab = document.querySelector(".meta.global_unique_id");
    const skuTAB = document.querySelector(".meta .value.sku");
    skuTAB.innerHTML = "N/B";
    skuNo.classList.add("hidden");
    globalUniqueIDtab.classList.add("hidden");
}
